
      import { retireServiceWorker } from './src/retire-service-worker.ts';

      void retireServiceWorker();
    